import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntDefaultUserIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99999 7.99999C9.54639 7.99999 10.8 6.74639 10.8 5.19999C10.8 3.6536 9.54639 2.39999 7.99999 2.39999C6.4536 2.39999 5.19999 3.6536 5.19999 5.19999C5.19999 6.74639 6.4536 7.99999 7.99999 7.99999ZM2.39999 11.4222C2.39999 9.91877 4.9072 8.69999 7.99999 8.69999C11.0928 8.69999 13.6 9.91877 13.6 11.4222V13.6L10.4 15.2H5.59999L2.39999 13.6V11.4222Z"
      />
    </SntIcon>
  );
};

export default SntDefaultUserIcon;
